"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniTimeChart_Old = exports.MiniTimeChart = exports.Title1MiniTimeChart = void 0;
var react_1 = __importStar(require("react"));
require("./index.less");
var title_1 = require("../title");
/** 带Title的分时图 */
function Title1MiniTimeChart(props) {
    return (react_1.default.createElement("div", { className: "titleminitc" },
        react_1.default.createElement(title_1.Title1, null,
            react_1.default.createElement(title_1.Title1.Main, null, props.link ?
                react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(props.quotecode) }, props.children)
                :
                    react_1.default.createElement(react_1.default.Fragment, null, props.children)),
            props.more && react_1.default.createElement(title_1.Title1.More, null,
                react_1.default.createElement(react_1.default.Fragment, null, props.more))),
        react_1.default.createElement("div", { className: props.border !== false ? 'titleminitcb' : '' },
            react_1.default.createElement("div", { style: { marginTop: 10 } },
                react_1.default.createElement(MiniTimeChart, __assign({}, props, { key: props.quotecode }))))));
}
exports.Title1MiniTimeChart = Title1MiniTimeChart;
/**
 * 迷你分时图(svg版)
 * @returns
 */
function MiniTimeChart(props) {
    var _a, _b, _c;
    var ref_container = (0, react_1.useRef)(null);
    var id = "quotechart" + Math.floor(Math.random() * 1000000 + 1);
    var thischart = (0, react_1.useRef)(null);
    var width = (_a = props.width) !== null && _a !== void 0 ? _a : 240;
    var height = (_b = props.height) !== null && _b !== void 0 ? _b : 180;
    var timeout = (_c = props.timeout) !== null && _c !== void 0 ? _c : 60;
    var draw = function () {
        if (window.miniquotechart2023 && props.quotecode) {
            var option = {
                container: document.getElementById(id),
                width: width,
                height: height,
                quotecode: props.quotecode,
                middle_day_line: true,
                ut: "bd1d9ddb04089700cf9c27f6f7426281",
                refreshTime: timeout * 1000
            };
            if (thischart.current == null) {
                thischart.current = new window.miniquotechart2023.Time(option);
            }
            thischart.current.draw();
        }
    };
    (0, react_1.useEffect)(function () {
        if (window.miniquotechart2023 && ref_container) {
            draw();
        }
    }, [props.quotecode]);
    return (react_1.default.createElement("div", { className: "minitimechart" },
        react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(props.quotecode) },
            react_1.default.createElement("div", { id: id, ref: ref_container }))));
}
exports.MiniTimeChart = MiniTimeChart;
/**
 * 迷你分时图
 * @returns
 */
function MiniTimeChart_Old(props) {
    var _a, _b, _c;
    var id = "quotechart" + Math.floor(Math.random() * 1000000 + 1);
    var thischart = (0, react_1.useRef)(null);
    var width = (_a = props.width) !== null && _a !== void 0 ? _a : 240;
    var height = (_b = props.height) !== null && _b !== void 0 ? _b : 180;
    var timeout = (_c = props.timeout) !== null && _c !== void 0 ? _c : 60;
    var draw = function () {
        if (window.emcharts3 && props.quotecode) {
            var option = {
                isqhquote: props.isqhquote || false,
                container: "#" + id,
                code: props.quotecode,
                token: "fa5fd1943c7b386f172d6893dbfba10b",
                width: width,
                height: height,
                color: {
                    border: "#E6E6E6"
                },
                "bigImg": {
                    "stauts": "show",
                    "text": "点击查看大图",
                    "color": "#aaaaaa",
                    "fontSize": 16
                },
                padding: {
                    left: 1,
                    right: 0,
                    top: 10,
                    bottom: 10
                },
                "timeline": [
                    {
                        "time": "11:30/13:00",
                        "position": 0.5
                    }
                ]
            };
            if (thischart.current == null) {
                thischart.current = new window.emcharts3.timemini(option);
            }
            thischart.current.draw();
        }
    };
    (0, react_1.useEffect)(function () {
        if (window.emcharts3) {
            var cd_1;
            if (timeout > 0) {
                cd_1 = setInterval(function () {
                    draw();
                }, timeout * 1000);
            }
            draw();
            return function () {
                clearInterval(cd_1);
            };
        }
    }, [props.quotecode]);
    return (react_1.default.createElement("div", { className: "minitimechart" },
        react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(props.quotecode) },
            react_1.default.createElement("div", { id: id }))));
}
exports.MiniTimeChart_Old = MiniTimeChart_Old;
